import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { getCurrentYear } from "../helper-js/current-year";
import RanksProLogo from "../../Assets/site-audit/RanksProLogo.png";
const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 20,
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 80, // Set vertical padding to 30 pixels
    borderStyle: "solid",
  },
  header: {
    paddingBottom: 20,
  },
  footer: {
    fontSize: 12,
    textAlign: "center",
    color: "grey",
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
  },
  logo: {
    width: 250,
    objectFit: "contain",
    maxHeight: 100,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    marginBottom: 20,
  },

  tableContainer: {
    marginBottom: 20,
  },

  keywordLoc: {
    flex: 1, // Each cell should take equal space within the row
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    justifyContent: "start",
    minHeight: 40,
    height: "100%",
    alignItems: "start",
    flexDirection: "column",
  },

  fixedWidthCell: {
    maxWidth: 80, // Disable flex for fixed width cells
  },
  cardContainer: {
    flexDirection: "row",
    flexWrap: "wrap", // Enable flex wrapping
    justifyContent: "space-between", // Arrange cards with equal spacing
    marginTop: 10,
  },
  card: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: 180,
    backgroundColor: "#FFFFFF",
    padding: 10,
    borderRadius: 5,
    marginBottom: 20,
  },
  image: {
    width: 30,
    height: 40,
  },
  title: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#6c757d",
  },
  description: {
    fontSize: 16,
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrowIcon: {
    width: 20,
    height: 20,
    objectFit: "contain",
  },
  view_button: {
    borderWidth: 1,
    borderColor: "#365486",
    padding: 5,
    borderRadius: 7,
    color: "#365486",
    fontSize: 11,
  },
  keyword_bold: {
    fontSize: 13,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  keyword: {
    fontSize: 11,
    color: "#6c757d",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rank: {
    fontSize: 11,
    color: "#6c757d",
    textAlign: "center",
    marginRight: 10,
  },

  pageNumber: {
    position: "absolute",
    fontSize: 11,
    bottom: 45,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  link_text: {
    fontSize: 7,
    textDecoration: "none",
    textOverflow: "hidden",
    textAlign: "start",
  },
  logoHead: {
    width: 125,
    objectFit: "contain",
    maxHeight: 80,
  },
});

function BacklistPdf({ pdfNewData }) {
  const DashImage = sessionStorage.getItem("dashboardImage");
  const Data = JSON.parse(sessionStorage.getItem("pdfSessionData"));
  const Web_url = Data?.Keyword;
  const image_logo = pdfNewData?.logo?.src || RanksProLogo;

  if (!DashImage) return;
  return (
    <Document>
      <Page size={"A4"} style={styles.page}>
        <View
          style={{
            alignItems: "center",
            display: "flex",
            height: "82vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image style={styles.logo} src={image_logo} />
          <Text style={{ marginBottom: 20 }}>Backlinks</Text>
          <Text style={styles.title}>Domain: {Web_url}</Text>
        </View>
      </Page>
      <Page size={"A4"} style={styles.page}>
        <View
          style={{
            ...styles.header,
            alignItems: pdfNewData?.reset
              ? "flex-start"
              : pdfNewData?.logo.position,
          }}
          fixed
        >
          <Image style={styles.logoHead} src={image_logo} />
        </View>

        <View style={{ ...styles.tableContainer }}>
          <View>
            <Image src={DashImage} />
          </View>
        </View>

        {pdfNewData?.footer && (
          <Text style={styles.footer} fixed>
            {pdfNewData?.footer}
          </Text>
        )}
      </Page>
    </Document>
  );
}

export default BacklistPdf;
